<template>
    <v-layout row justify-center>
        <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-flex xs12>
                    <div class="text-xs-left">
                        <v-btn
                                flat
                                @click="handleCloseDialog"
                        >
                            <v-icon left small>fal fa-chevron-left</v-icon>
                          {{ $vuetify.t('$vuetify.back') }}
                        </v-btn>
                    </div>
                </v-flex>
                <v-card-text>
                    <ItemsListMenuLevels
                            :levels="levels"
                            v-model="value">
                    </ItemsListMenuLevels>
                </v-card-text>

                <v-card-actions>
                  <v-layout align-center justify-center>
                    <v-btn color="primary"  @click="handleCloseDialog">
                        <v-icon left small>fal fa-check</v-icon>
                        {{ $vuetify.t('$vuetify.confirm') }}
                    </v-btn>
                  </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>

    export default {
        name: "DialogListMenuLevels",
        //The import is performed here because this component is recursive
        components: {
            'ItemsListMenuLevels': () => import('@/components/ItemsListMenuLevels.vue')
        },
        props: {
            levels: Array,
            show: Boolean,
            value: Object
        },
        data() {
            return {
                dialog: true
            }
        },
        methods: {
            /**
             *
             */
            handleCloseDialog() {
                //este close bate com o @close de quando se chama o Componente text
                this.$emit('close', false);
            },
        }
    }
</script>

<style scoped>

</style>